import { render, staticRenderFns } from "./ProjectLayout.vue?vue&type=template&id=637576a1&scoped=true&"
import script from "./ProjectLayout.vue?vue&type=script&lang=js&"
export * from "./ProjectLayout.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLayout.vue?vue&type=style&index=0&id=637576a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637576a1",
  null
  
)

export default component.exports